import { openMeldRequestContextSchema } from "../daemon/profile-identity.js";
import { spaceThreadContextSchema } from "./space-thread.js";
import * as z$1 from "zod/v4";
//#region src/schemas/space-mesh/agent-reply-placement.ts
const AGENT_REPLY_PLACEMENT_HEADER = "x-openmeld-agent-reply-placement";
function agentStreamForReplyPlacementReader(stream, supported) {
	if (supported || stream.replyThreadRootSignalId === void 0) return stream;
	if (stream.replyThreadRootSignalId !== null) return null;
	return {
		...stream,
		replyThreadRootSignalId: void 0
	};
}
function agentStreamsForReplyPlacementReader(streams, supported) {
	return streams.flatMap((stream) => {
		const projected = agentStreamForReplyPlacementReader(stream, supported);
		return projected ? [projected] : [];
	});
}
const agentReplyPlacementSchema = z$1.enum(["conversation", "thread"]);
const centerAgentSetReplyPlacementInputSchema = z$1.strictObject({
	context: openMeldRequestContextSchema,
	placement: agentReplyPlacementSchema
});
const resolveNativeReplyPlacementInputSchema = z$1.strictObject({
	spaceId: z$1.string().min(1),
	dispatchId: z$1.string().min(1),
	sourceSignalId: z$1.string().min(1),
	profileId: z$1.string().min(1),
	defaultToThread: z$1.boolean(),
	lock: z$1.boolean(),
	placement: agentReplyPlacementSchema.optional()
});
const nativeReplyPlacementSchema = z$1.strictObject({
	dispatchId: z$1.string().min(1),
	sourceSignalId: z$1.string().min(1),
	profileId: z$1.string().min(1),
	threadContext: spaceThreadContextSchema.nullable(),
	locked: z$1.boolean()
});
//#endregion
export { AGENT_REPLY_PLACEMENT_HEADER, agentReplyPlacementSchema, agentStreamForReplyPlacementReader, agentStreamsForReplyPlacementReader, centerAgentSetReplyPlacementInputSchema, nativeReplyPlacementSchema, resolveNativeReplyPlacementInputSchema };

//# sourceMappingURL=agent-reply-placement.js.map